// Cobblestone recipe — plan §4.2: worley → F2-F1 mortar groove → ramp(hash(cellID)) per-stone
// colour; edgeDist → normal + height (the layer's height field drives the detail normal).
// Immutable built-in root (never mutate — extend/fork instead).
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const COBBLESTONE_RECIPE_ID = "cobblestone";

export const cobblestoneRecipe = new MaterialRecipe({
	id: COBBLESTONE_RECIPE_ID,
	name: "Cobblestone",
	roughness: 0.6,
	params: [
		new ParamSchema({key: "cobble_scale", label: "Stone scale", kind: "scalar", min: 0.1, max: 4, default: 0.2}),
		new ParamSchema({key: "cobble_jitter", label: "Stone jitter", kind: "scalar", min: 0, max: 1, default: 0.45}),
		new ParamSchema({key: "cobble_stoneRamp", label: "Stone ramp", kind: "ramp", default: [0, 0.55, 0.55, 0.55, 1, 0.78, 0.78, 0.78]}),
		new ParamSchema({key: "cobble_mortarColor", label: "Mortar colour", kind: "color", default: [0.15, 0.14, 0.13]}),
		new ParamSchema({key: "cobble_grooveInner", label: "Groove inner", kind: "scalar", min: 0, max: 1, default: /*0.12*/ 0.04}),
		new ParamSchema({key: "cobble_grooveOuter", label: "Groove outer", kind: "scalar", min: 0, max: 1, default: /*0.45*/ 0.15}),
		new ParamSchema({key: "cobble_stoneHeight", label: "Stone height", kind: "scalar", min: 0, max: 0.5, default: 0.08}),
		new ParamSchema({key: "cobble_grooveDepth", label: "Groove depth", kind: "scalar", min: -0.2, max: 0, default: -0.02}),
	],
	layers: [
		new MaterialLayer({
			id: "stones",
			primitive: "worley",
			args: {
				scale: {ref: "cobble_scale"},
				jitter: {ref: "cobble_jitter"},
				stoneRamp: {ref: "cobble_stoneRamp"},
				mortarColor: {ref: "cobble_mortarColor"},
				grooveInner: {ref: "cobble_grooveInner"},
				grooveOuter: {ref: "cobble_grooveOuter"},
				stoneHeight: {ref: "cobble_stoneHeight"},
				grooveDepth: {ref: "cobble_grooveDepth"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
